import React from 'react';
import {
  AAMBeaconControlGroup,
  AAMBeaconControl
} from 'components/shared/Beacon';
import './FundingMethodSelection.scss';
import { FUNDING_METHODS } from 'services/OnBoardingJourney';
import { connect } from 'react-redux';
import { isExchangeEligible } from 'state/eligibility/EligibilitySelector';
import { isTaxableAccount } from 'services/AccountTypes';
import { getFundingMethod } from 'state/missions/MissionsSelectors';
import Store from 'state/Store';
import { receivedFundingMethod } from 'state/missions/MissionActions';
const FundingMethodSelection = ({
  fundingMethod,
  isExchangeEligible,
  account: { accountTypeId } = {}
}) => {

  const taxableSweep = isTaxableAccount(accountTypeId);
  return (
    <div className="funding-method-card-container">
      <div className="top">
        <h3 className="title">Choose your sweep account funding method</h3>
        <p className="text-body">
          Brokerage transactions are made using assets in
          a sweep account which holds funds while you decide how to invest.
        </p>
      </div>
      <div className="bottom">
        <div className="beacon-on-light">
          <AAMBeaconControlGroup required>
            <div slot="label">
              How would you like to add assets to your money market account?</div>
            <AAMBeaconControl inline>
              <label htmlFor={FUNDING_METHODS.ACH}
                className="b-typography-sans-serif--body--100 b-font-weight-light"
                slot="label">
                Use money from my bank account (manual or automatic)
              </label>
              <input type="radio"
                onChange={(event) => Store.dispatch(receivedFundingMethod(event.target.value))}
                checked={fundingMethod === FUNDING_METHODS.ACH}
                value={FUNDING_METHODS.ACH}
                id={FUNDING_METHODS.ACH}
                name="funding-method-selection" />
            </AAMBeaconControl>

            {isExchangeEligible && (
              <AAMBeaconControl inline>
                <label htmlFor={FUNDING_METHODS.EXCHANGE}
                  className="b-typography-sans-serif--body--100 b-font-weight-light"
                  slot="label">
                  Exchange existing eligible T. Rowe Price investments
                </label>
                <input type="radio"
                  onChange={(event) => Store.dispatch(receivedFundingMethod(event.target.value))}
                  checked={fundingMethod === FUNDING_METHODS.EXCHANGE}
                  value={FUNDING_METHODS.EXCHANGE}
                  id={FUNDING_METHODS.EXCHANGE}
                  name="funding-method-selection" />
              </AAMBeaconControl>
            )}

            <AAMBeaconControl inline>
              <label htmlFor={FUNDING_METHODS.TRANSFER}
                className="b-typography-sans-serif--body--100 b-font-weight-light"
                slot="label">
                Transfer investments from another firm to T. Rowe Price
              </label>
              <input type="radio"
                onChange={(event) => Store.dispatch(receivedFundingMethod(event.target.value))}
                checked={fundingMethod === FUNDING_METHODS.TRANSFER}
                value={FUNDING_METHODS.TRANSFER}
                id={FUNDING_METHODS.TRANSFER}
                name="funding-method-selection" />
            </AAMBeaconControl>

            {!taxableSweep &&
              (<AAMBeaconControl inline>
                <label htmlFor={'non-taxable-rollover'}
                  className="b-typography-sans-serif--body--100 b-font-weight-light"
                  slot="label">
                  Roll over assets from an employer retirement plan, such as a 401(k) or 403(b)
                </label>
                <input type="radio"
                  onChange={(event) => Store.dispatch(receivedFundingMethod(event.target.value))}
                  checked={fundingMethod === FUNDING_METHODS.DIRECT_ROLLOVER ||
                    fundingMethod === FUNDING_METHODS.INDIRECT_ROLLOVER}
                  value={FUNDING_METHODS.DIRECT_ROLLOVER}
                  id={'non-taxable-rollover'}
                  name="funding-method-selection" />
              </AAMBeaconControl>)}

            <AAMBeaconControl inline>
              <label htmlFor={FUNDING_METHODS.CHECK}
                className="b-typography-sans-serif--body--100 b-font-weight-light"
                slot="label">
                Mail a check
              </label>
              <input type="radio"
                onChange={(event) => Store.dispatch(receivedFundingMethod(event.target.value))}
                checked={fundingMethod === FUNDING_METHODS.CHECK}
                value={FUNDING_METHODS.CHECK}
                id={FUNDING_METHODS.CHECK}
                name="funding-method-selection" />
            </AAMBeaconControl>
            <div slot="error">Please select one of these options.</div>
          </AAMBeaconControlGroup>
        </div>

      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  fundingMethod: getFundingMethod(state),
  isExchangeEligible: isExchangeEligible(state)
});

export default connect(mapStateToProps)(FundingMethodSelection);
